import options from './layout.component';

export default {
    selector: 'dtLayout',
    options
};



// WEBPACK FOOTER //
// ./app/common/layout/index.js